export default import.meta.ROLLDOWN_FILE_URL_dov4y4GgHUuOZZXEDigs4Q